import isobject from 'isobject';
import { Duck, createAction, createSelector, DuckSelector } from '@atc/modular-redux';
import _get from 'lodash/get';
import inventoryDuckSelectors from './inventoryDuckCreator/inventoryDuckSelectors';
import ownersDuckSelectors from './ownersDuckCreator/ownersDuckSelectors';
import hydrateInventory from './inventoryDuckCreator/hydrateInventory';
export default function resultsDuckCreator(_temp) {
  let {
    namespace,
    store = 'results',
    storePath,
    initialState = {
      activeResults: [],
      count: 0,
      stats: {},
      loading: false,
      initialLoad: true,
      fetchError: false,
      isWebComponentReady: false
    },
    ...rest
  } = _temp === void 0 ? {} : _temp;
  return new Duck({
    ...rest,
    initialState,
    namespace,
    store,
    storePath,
    consts: {},
    types: ['ADD_ACTIVE_RESULT', 'ADD_ACTIVE_RESULTS', 'CLEAR', 'SET_ACTIVE_RESULTS', 'SET_COUNT', 'SET_STATS', 'SET_LOADING', 'SET_FETCH_ERROR', 'SET_WEB_COMPONENT_AVAILABILITY'],
    reducer: (state, action, _ref) => {
      let {
        types
      } = _ref;
      switch (action.type) {
        case types.ADD_ACTIVE_RESULT:
          {
            const {
              payload
            } = action;
            const newState = {
              ...state,
              loading: false,
              initialLoad: false
            };
            if (Array.isArray(state.activeResults)) {
              // Do not mutate state
              const activeResults = [].concat(state.activeResults);

              // If it is a result object then we add the result
              // to the active results at the specified index
              if (isobject(payload)) {
                const {
                  value,
                  index
                } = payload;
                activeResults[index] = value;
                return {
                  ...newState,
                  activeResults
                };
              }
              activeResults.push(payload);
              return {
                ...newState,
                activeResults
              };
            }
            break;
          }
        case types.ADD_ACTIVE_RESULTS:
          {
            const {
              payload = []
            } = action;
            if (Array.isArray(state.activeResults)) {
              const activeResults = [].concat(state.activeResults);

              // Iterate over each element in the payload
              // and decide how to handle each result
              payload.forEach(result => {
                if (isobject(result)) {
                  const {
                    value,
                    index
                  } = result;
                  activeResults[index] = value;
                } else {
                  activeResults.push(result);
                }
              });
              return {
                ...state,
                loading: false,
                initialLoad: false,
                activeResults
              };
            }
            return state;
          }
        case types.CLEAR:
          {
            return {
              ...initialState
            };
          }
        case types.SET_COUNT:
          {
            return {
              ...state,
              count: action.payload
            };
          }
        case types.SET_STATS:
          {
            return {
              ...state,
              stats: action.payload
            };
          }
        case types.SET_ACTIVE_RESULTS:
          {
            return {
              ...state,
              loading: false,
              initialLoad: false,
              activeResults: action.payload
            };
          }
        case types.SET_LOADING:
          {
            return {
              ...state,
              loading: true
            };
          }
        case types.SET_FETCH_ERROR:
          {
            return {
              ...state,
              fetchError: action.payload
            };
          }
        case types.SET_WEB_COMPONENT_AVAILABILITY:
          {
            return {
              ...state,
              isWebComponentReady: action.payload
            };
          }
        default:
      }
      return state;
    },
    creators: _ref2 => {
      let {
        types
      } = _ref2;
      return {
        addActiveResult: createAction(types.ADD_ACTIVE_RESULT),
        addActiveResults: createAction(types.ADD_ACTIVE_RESULTS),
        clear: createAction(types.CLEAR),
        setActiveResults: createAction(types.SET_ACTIVE_RESULTS),
        setCount: createAction(types.SET_COUNT),
        setStats: createAction(types.SET_STATS),
        setLoading: createAction(types.SET_LOADING),
        setFetchError: createAction(types.SET_FETCH_ERROR),
        setWebComponentAvailability: createAction(types.SET_WEB_COMPONENT_AVAILABILITY)
      };
    },
    selectors: duck => ({
      getActiveResults: new DuckSelector(selectors => createSelector(selectors.getDuckState, localState => localState.activeResults || [])),
      isResultsArray: new DuckSelector(selectors => createSelector(selectors.getActiveResults, activeResults => Array.isArray(activeResults))),
      getResultsCount: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'count')),
      getActiveResultsCount: new DuckSelector(selectors => createSelector(selectors.isResultsArray, selectors.getActiveResults, (isResultsArray, activeResults) => {
        if (isResultsArray) {
          return activeResults.length;
        }
        return Object.keys(activeResults).reduce((acc, key) => ({
          ...acc,
          [key]: _get(activeResults, key, []).length
        }), {});
      })),
      /**
       * Hydrate the active result array or object of arrays with their data from the inventory and user state collections
       */
      getActiveInventory: new DuckSelector(selectors => createSelector(selectors.isResultsArray, selectors.getActiveResults, state => inventoryDuckSelectors.getInventory(state), state => ownersDuckSelectors.getOwners(state), state => _get(state, 'brand', 'atc'), (isResultsArray, activeResults, inventory, owners, brand) => {
        if (isResultsArray) {
          return activeResults.map(id => hydrateInventory(id, inventory, owners, brand));
        }
        return Object.keys(activeResults).reduce((acc, key) => ({
          ...acc,
          [key]: _get(activeResults, key, []).map(id => hydrateInventory(id, inventory, owners, brand))
        }), {});
      })),
      hasActiveResults: new DuckSelector(selectors => createSelector(selectors.isResultsArray, selectors.getActiveResultsCount, (isResultsArray, count) => {
        if (isResultsArray) {
          return count > 0;
        }
        return Object.keys(count).reduce((acc, key) => ({
          ...acc,
          [key]: _get(count, key, []) > 0
        }), {});
      })),
      getResultLoading: new DuckSelector(selectors => state => selectors.getDuckState(state).loading),
      getIsWebComponentReady: new DuckSelector(selectors => state => selectors.getDuckState(state).isWebComponentReady)
    })
  });
}